export const regreq="regreq"
export const regsucc="regsucc"
export const regfail="regfail"